import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#1b66f3",
      d: "M6.75 5.638s-.92-.077-.92.686v3.504h5.895v1.067s0 .533-.535.533H5.83V16h6.432s3.904-.61 3.904-4.572v-5.79zM16.09 0H4.453C.243.99.166 4.419.166 4.419V16h4.44V5.486c0-.914.919-1.067.919-1.067h10.564z"
    }, null, -1)
  ]))]))
}
export default { render: render }